import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './plugins/nutui'
import './plugins/axios'
import './assets/fonts/iconfont/iconfont.css'
import './assets/fonts/iconfont/iconfont.js'
import {FormModel, Input, Button} from 'ant-design-vue'
import VueClipboard from 'vue-clipboard2';
import VueI18n from 'vue-i18n' //导入包
// 工具类
import util from './utils/util.js';

let title = ' '
Vue.config.productionTip = false
Vue.prototype.requestToken = 'f66621ba4fe8ae401b28146de7a2f30b';
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title + title
    }
    next()
})
Vue.use(VueI18n);      //使用use挂载
const i18n=new VueI18n({    //通过new出一个i18n的实例
    locale:Vue.ls.get('LanguageType')?Vue.ls.get('LanguageType'):'zh-CN',    // 语言标识 //this.$i18n.locale // 通过切换locale的值来实现语言切换
    messages: {
        'zh': require('./assets/lang/zh'),
        'en': require('./assets/lang/en')
    }
})
// 快速导航列表
Vue.prototype.NAVLIST = [
    {
        id: 1,
        text: '首页',
        url: '/',
        icon: 'https://img11.360buyimg.com/imagetools/jfs/t1/117646/2/11112/1297/5ef83e95E81d77f05/daf8e3b1c81e3c98.png'
    },
    {
        id: 2,
        text: '分类',
        url: '/goods/category',
        icon: 'https://img12.360buyimg.com/imagetools/jfs/t1/119490/8/9568/1798/5ef83e95E968c69a6/dd029326f7d5042e.png'
    },
    {
        id: 3,
        text: '购物车',
        url: '/order/cart',
        icon: 'https://img14.360buyimg.com/imagetools/jfs/t1/130725/4/3157/1704/5ef83e95Eb976644f/b36c6cfc1cc1a99d.png'
    },
    {
        id: 4,
        text: '我的',
        url: '/member',
        icon: 'https://img12.360buyimg.com/imagetools/jfs/t1/147573/29/1603/1721/5ef83e94E1393a678/5ddf1695ec989373.png'
    }
]

// 跳转快速导航
Vue.prototype.selectedNav = function (e) {
    router.push({
        path: e.item.url
    })
}
//当前用户id
Vue.prototype.getUserId = function () {
    return Vue.ls.get('user_id');
}

// 执行用户登陆
Vue.prototype.doLogin = function () {
    let pages = this.$route;
    Vue.ls.set('currentPage', pages.path);
    Vue.ls.set('currentPageParam', pages.query);
    // 跳转用户授权页面
    router.push({
        path: '/login/login'
    })
}

Vue.prototype.GLOBAL = {cart_total_num: 0}; // 购物车数量

// 购物车数量
Vue.prototype.setTabBarBadge = function () {
    let _this = this;
    _this._get('wxapp/cartNum', {}, res => {
        _this.GLOBAL.cart_total_num = res.total_num;
    })
}


/**
 * 记录 formid
 */
Vue.prototype.saveFormId = function (formId) {
    let _this = this;
    if (formId === 'the formId is a mock one') {
        return false;
    }
    _this._post_form('wxapp.formId/save', {
        formId: formId
    }, null);
}

/**
 * 验证是否存在user_info
 */
Vue.prototype.validateUserInfo = function () {
    let user_info = Vue.ls.get('user_info');
    return !!Vue.ls.get('user_info');
}

/**
 * 跳转指定页面
 */
Vue.prototype.navigationTo = function (url, params = {}) {
    router.push({
        path: url,
        query: params,
    }).catch(error => error)
}

/**
 * 返回指定页面参数
 */
Vue.prototype._params = function () {
    return this.$route.query;
}

/**
 * 获取用户信息并存入缓存
 */
Vue.prototype.getUserInfo = function () {
    let _this = this;
    _this._post_form('user.index/detail', {}, res => {
        if (res.data.userInfo) {
            Vue.ls.set('userInfo', res.data);
        } else {
            // 登陆失效去登陆
            Vue.ls.remove('userInfo');
            _this.doLogin();
        }
    })
}

/**
 * get 请求
 */
Vue.prototype._get = function (url = '', data, success, fail) {
    let _this = this;
    url = '/api/' + url;
    data.params = {
        sss: 'h5',
        ...data,
        wxapp_id: 10001,
        token: Vue.ls.get('token')
        // token: _this.requestToken
    };
    _this.axios.get(url, data).then(res => {
        if (typeof res !== 'object') {
            _this.$toast.fail('网络请求出错');
            _this.$toast.loading('网络请求出错', {
                coverColor: "rgba(0,0,0,0.5)",
                duration: 300, // 自定义关闭时长
            });
            return false;
        }
        if (res.code === -1) {
            // 登陆失效,并且需要验证登陆
            _this.doLogin();
            return false;
        } else if (res.code === 0) {
            if (res.msg) {
                _this.$toast.loading(res.msg, {
                    coverColor: "rgba(0,0,0,0.5)",
                    duration: 300, // 自定义关闭时长
                });
                _this.$toast.fail(res.msg, function () {
                    fail && fail(res);
                });
            }
            return false;
        } else {
            success && success(res);
        }
    })
}


/**
 * post 请求
 */
Vue.prototype._post_form = function (url, data, success, fail) {
    let _this = this;
    url = '/api/' + url;
    // 判断文件上传(选择不同追加token方式)this.requestToken
    if (typeof data.get == 'function' && data.get('iFile')) {
        data.append('wxapp_id', 10001);
        data.append('token', Vue.ls.get('token'));
        // data.append('token', _this.requestToken);
    } else {
        data.wxapp_id = 10001;
        data.token = Vue.ls.get('token');
        // data.token = _this.requestToken;
    }
    _this.axios.post(url, data).then(res => {
        if (typeof res !== 'object') {
            _this.$toast.fail('网络请求出错');
            _this.$toast.loading('网络请求出错', {
                coverColor: "rgba(0,0,0,0.5)",
                duration: 300, // 自定义关闭时长
            });
            return false;
        }
        if (res.code === -1) {
            _this.doLogin();
            return false;
        } else if (res.code === 0) {
            if (res.msg) {
                _this.$toast.loading(res.msg, {
                    coverColor: "rgba(0,0,0,0.5)",
                    duration: 300, // 自定义关闭时长
                });
                _this.$toast.fail(res.msg, function () {
                    fail && fail(res);
                });
            }
            return false;
        }
        success && success(res);
    })
}

/**
 * 仿小程序 setData
 */
Vue.prototype.setData = function (data) {
    return Object.assign(this._data, data);
}

/**
 * 验证登陆
 */
Vue.prototype.checkIsLogin = function () {
    return Vue.ls.get('token') != '' && Vue.ls.get('user_id') != '';
}

/**
 * 获取场景值(scene)
 */
Vue.prototype.getSceneData = function (query) {
    return query.scene ? util.scene_decode(query.scene) : {};
}

/**
 * 生成转发的url参数
 */
Vue.prototype.getShareUrlParams = function (params) {
    let _this = this;
    return util.urlEncode(Object.assign({
        referee_id: _this.getUserId()
    }, params));
}

Vue.use(FormModel);
Vue.use(VueClipboard);
Input.install(Vue);
Button.install(Vue);
new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
